<template>
    <div class="vacate">
        <div class="card" v-for="item in vacateInfoList" :key="item.index">
            <div class="left">
                <img style="width: 75px;height: 75px ; border-radius: 15px;"
                    :src="'http://shopxmhs.oss-cn-beijing.aliyuncs.com/8ed87202305271831213652.png'" />
            </div>
            <Button @click="submit($event, item.id)" :plain="true"
                style="background:#2980f7;color: #fff;width:63px;height: 32px;font-size: 16px;float: right;margin-bottom: -75px;">同意</Button>
            <Button @click="cancel($event, item.id)" :plain="true"
                style="background:#2980f7;color: #fff;width:63px;height: 32px;font-size: 16px;float: right;margin-top:37px;">拒绝</Button>

            <div class="right">
                <div class="line">
                    <div class="name"><Icon type="logo-octocat"  size="22" color="#ffc524f0"/>&#160&#160{{ item.vacate_name }}</div>
                    
                    <!-- <div>{{ item.vacate_name }}</div> -->
                </div>
                <div class="line">
                    <div class="time"><Icon type="ios-clock-outline" size="22" color="#ffc524f0" />&#160&#160{{ item.vacate_time }}</div>
                    <!-- <div>{{ item.vacate_time }}</div> -->
                </div>
                <div class="line">
                    <div class="type"><Icon type="ios-pricetags-outline" size="22" color="#ffc524f0"  />&#160&#160{{ item.type }}</div>
                </div>
                <div class="line">
                    <div class="vacaate"><Icon type="ios-chatboxes-outline" size="22" color="#ffc524f0" />&#160&#160{{ item.cause }}</div>
                </div>
            </div>

        </div>
    </div>
</template>
  
<style scoped>
.vacate {
    /* position: relative;
    width: 100vw;
    height: 100vh;
    padding: 0.2rem 0.2rem;
    
    overflow-y: scroll;
    padding-bottom: 1.5rem; */
    /* border-radius: 15px;
    box-shadow: .1rem 2.1rem 2.1rem rgb(214, 212, 212); */
}

.card {
    background-color: #2980f7;    
    padding: 10px;
    margin: 10px;
    /* font-size: 24px; */
    border-radius: 15px;
    box-shadow: 0.15rem 0.15rem 0.5em rgb(133, 131, 131);
}
.left {

    float: left;
    /* margin-top: 28px;
    margin-left: 21px; */

}

.leftline {
    /* width: 1.2rem;
    height: 1.2rem; */
    /* margin-right: 0.4rem;
    border-radius: 0.2rem;
    overflow: hidden; */
}

.line {
    margin-top: 6px;
    /* width: 240px; */
}

/* .left img {
  height: 40px;
  width:  40px;
  margin-top: 52px;
} */
.right {
    margin-left: 120px;
    /* width: 200px;
    margin-top: 12px; */
    
}
</style>
  
<script>
import { vacateInfo1, vacatesend1, getUser } from "@api/user";

export default {
    name: "vacate",
    data: function () {
        return {
            userInfo: {},
            vacateInfoList: [],

        };
    },
    methods: {
        User: function () {
            let that = this;
            getUser().then(res => {
                that.userInfo = res.data;
                // console.log(that.userInfo)
                // this.gradeLseeon(res.data.uid);
            });
        },
        vacateInfo() {
            vacateInfo1().then(res => {
                this.vacateInfoList = res.data.data;
                // console.log(this.vacateInfoList)
            });

        },
        submit(e, id) {
            var _this = this,
                data = {
                    id: id,
                    pujia: this.userInfo.uid,
                    status: 1
                };
            vacatesend1(data).then(res => {
                if (res.status == 200) {
                    _this.$Message.success('操作成功已同意');
                    this.vacateInfo();
                    this.User();
                }
            }).catch(res => {
                if (res.status == 400) {
                    _this.$Message.err('操作失败');
                }
            });
            setTimeout(() => {
                this.$router.go(0);
            }, 1000);

        },
        cancel(e,id) {
            var _this = this,
                data = {
                    id: id,
                    pujia: this.userInfo.uid,
                    status: 2
                };
            vacatesend1(data).then(res => {
                if (res.status == 200) {
                    _this.$Message.success('操作成功已拒绝');
                    this.vacateInfo();
                    this.User();
                }
            }).catch(res => {
                if (res.status == 400) {
                    _this.$Message.err('操作失败');
                }
            });
            setTimeout(() => {
                this.$router.go(0);
            }, 1000);
        }
    },
    watch: {
    },
    mounted: function () {
        this.User();
        this.vacateInfo();
    }
};
</script>
  